import { render, staticRenderFns } from "./CartPayment.vue?vue&type=template&id=1fa34814&"
import script from "./CartPayment.vue?vue&type=script&lang=js&"
export * from "./CartPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports